import { ISessionUserDto } from "../dtos/session-user.dto";

export class SessionService {
  static instance: SessionService;
  static storageKeyUser = "session-user";
  static storageKeyJWT = "session-jwt";

  static getInstance() {
    if (!SessionService.instance)
      SessionService.instance = new SessionService();

    return SessionService.instance;
  }

  token: string | undefined;
  user: ISessionUserDto | undefined;

  constructor() {
    let sessionUser = localStorage.getItem(SessionService.storageKeyUser);
    if (sessionUser) this.user = JSON.parse(sessionUser);

    let sessionToken = localStorage.getItem(SessionService.storageKeyJWT);
    if (sessionToken) this.token = sessionToken;
  }

  setUser(user: ISessionUserDto): SessionService {
    this.user = user;
    localStorage.setItem(SessionService.storageKeyUser, JSON.stringify(user));
    return this;
  }

  setToken(token: string): SessionService {
    this.token = token;
    localStorage.setItem(SessionService.storageKeyJWT, token);
    return this;
  }

  clear(): void {
    localStorage.removeItem(SessionService.storageKeyUser);
    localStorage.removeItem(SessionService.storageKeyJWT);

    delete this.token;
    delete this.user;
  }

  isActive(): boolean {
    return (
      typeof this.token !== "undefined" && typeof this.user !== "undefined"
    );
  }
}

export default SessionService;
